import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress, Alert } from "@mui/material";
import { axiosPrivate } from "src/common/axiosProtected";

export default function TermsAndConditions({ billingPartyUuid }) {
  const [termsData, setTermsData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      if (!billingPartyUuid) {
        setError("No billing party UUID provided");
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const response = await axiosPrivate.get(
          `/api/v1/customers-terms-and-conditions/by-customer/${billingPartyUuid}`,
        );
        setTermsData(response.data.data);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            err.message ||
            "Failed to fetch terms and conditions",
        );
        console.error("Error fetching terms and conditions:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTermsAndConditions();
  }, [billingPartyUuid]);

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        {error}
      </Alert>
    );
  }

  if (!termsData) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No terms and conditions available
        </Typography>
      </Box>
    );
  }

  // Get the first item from the data array
  const termsItem = Array.isArray(termsData) ? termsData[0] : termsData;

  console.log("termsItem", termsItem);
  const description =
    termsItem?.description ||
    termsItem?.termsAndConditions?.description ||
    "No description available";

  return (
    <Box
      sx={{
        backgroundColor: "#FAF9EF",
        border: "1px solid #f0e68c",
        borderRadius: 2,
        p: { xs: 1.5, sm: 2 },
        m: 2,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: "#b5b3a1",
          fontSize: { xs: "0.8rem", sm: "0.875rem" },
          lineHeight: 1.6,
          whiteSpace: "pre-wrap",
        }}
      >
        {description}
      </Typography>
    </Box>
  );
}
